export const indicators = {
  gdhi: "Monitor de saúde digital global",
  indicatorGuide: "Guia do Indicador",
  paragraph1:
    "O <a class='link-blue' href='http://digitalhealthmonitor.org' target='_blank'>Monitor de saúde digital global (GDHM)</a> é um " +
    "recurso digital interativo que acompanha, monitoriza e avalia o uso da tecnologia digital na saúde em todos os países. O GDHM usa sete " +
    "categorias de indicadores-chave para acompanhar o progresso.",
  indicator: "Indicador",
  selected_indicator: "indicador selecionado",
};
